// extracted by mini-css-extract-plugin
export default {"systemActive":"SystemActive_systemActive__iHGnM","header":"SystemActive_header__WABz-","info":"SystemActive_info__p9-R6"};